import { apply, equals, isNil, max, min, range } from 'ramda'

import { SelectOption } from '@driftt/dds'

import { isNilOrEmpty } from 'utils/ramda'

export const getMin = (minValue: number | null, maxValue: number | null) => {
  if (!isNil(minValue) && !isNil(maxValue)) {
    return min(minValue, maxValue)
  }
  return minValue
}

export const getMax = (minValue: number | null, maxValue: number | null) => {
  if (!isNil(minValue) && !isNil(maxValue)) {
    return max(minValue, maxValue)
  }
  return maxValue
}

export const getMinHourFromRangeAsNumber = (range: string[]): number | null => {
  if (isNilOrEmpty(range)) {
    return null
  }
  const rangeAsNumbers = range.map((hour) => Number(hour))
  return apply(Math.min, rangeAsNumbers)
}

export const getMaxHourFromRangeAsNumber = (range: string[]): number | null => {
  if (isNilOrEmpty(range)) {
    return null
  }
  const rangeAsNumbers = range.map((hour) => Number(hour))
  // Increment max by 1 because max value is exclusive in the formatted range of values
  return apply(Math.max, rangeAsNumbers) + 1
}

export const getRangeAsStringValues = (min: number, max: number) =>
  // Formats a list of hours from min (inclusive) to max (exclusive) as strings
  range(min, max).map((hour) => hour.toString())

const formatHourDisplay = (hour: number): number => {
  if (equals(hour, 0)) {
    return 12
  }
  return hour > 12 ? hour - 12 : hour
}

export const formatHourOfDayOptions = (): SelectOption[] => {
  return range(0, 24).map((hour) => {
    const hourDisplay = formatHourDisplay(hour)
    return {
      label: `${hourDisplay}:00 ${hour >= 12 ? 'PM' : 'AM'}`,
      value: `${hour}`,
    }
  })
}
